import { render, staticRenderFns } from "./ViewManagerList.vue?vue&type=template&id=2027c3c6&scoped=true&"
import script from "./ViewManagerList.vue?vue&type=script&lang=js&"
export * from "./ViewManagerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2027c3c6",
  null
  
)

export default component.exports